// Cadres des aperçus : un téléphone (écran sombre de l'app), une fenêtre de
// navigateur (dashboard coach web), et une fenêtre modale du dashboard posée
// sur son voile, dans la fenêtre de navigateur.
import React from "react";
import useEchelle from "./useEchelle";

export function Telephone({ children, className = "" }) {
	return (
		<div className={`gs-tel ${className}`.trim()}>
			<div className="gs-tel-ecran">
				<span className="gs-tel-encoche" />
				{children}
			</div>
		</div>
	);
}

export function FenetreWeb({ adresse = "gymnote.fr/coach", children, className = "" }) {
	return (
		<div className={`gs-web ${className}`.trim()}>
			<div className="gs-web-barre">
				<i />
				<i />
				<i />
				<span className="gs-web-adresse">{adresse}</span>
			</div>
			<div className="gs-web-corps">{children}</div>
		</div>
	);
}

// Une modale du dashboard à sa taille réelle : `largeur` est celle de l'écran
// simulé (voile compris), le tout réduit à la largeur de la fenêtre. `page`
// esquisse, floutée sous le voile, l'écran d'où la modale s'ouvre.
// `voile` et `flou` reprennent l'overlay réel de la modale.
export function ModaleWeb({ largeur, marge, voile, flou, page, children }) {
	const [ref, echelle, recadre] = useEchelle(largeur);
	return (
		<FenetreWeb className="gs-mw-fenetre">
			<div className={`gs-mw-cadre${recadre ? " gs-mw-cadre--recadre" : ""}`} ref={ref}>
				<div className="gs-mw-fond" style={{ width: largeur, padding: marge, zoom: echelle }}>
					<div className={`gs-mw-page gs-mw-page--${page}`} style={{ filter: `blur(${flou}px)` }}>
						{page === "programmes" ? (
							<>
								<span className="gs-mw-titre" />
								<span className="gs-mw-bouton" />
								<span className="gs-mw-carte" />
								<span className="gs-mw-carte" />
								<span className="gs-mw-carte" />
							</>
						) : (
							<>
								<span className="gs-mw-rail" />
								<span className="gs-mw-entete" />
								<span className="gs-mw-carte" />
								<span className="gs-mw-carte" />
							</>
						)}
					</div>
					<div className="gs-mw-voile" style={{ background: voile }} />
					<div className="gs-mw-contenu">{children}</div>
				</div>
			</div>
		</FenetreWeb>
	);
}
